import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matchesSubCat',
  pure: false
})

export class MatchesSubCatPipe implements PipeTransform {
  // transform(items: any[], filter: ProductInterface): any {
  //   if (!items || !filter) {
  //     return items;
  //   }
  //   return items.filter(item => item.prodSubCatLink.indexOf(filter.prodSubCatLink) !== -1);
  // }
  transform(items: any[], matchesSubCat: (item: any) => boolean): any {
    if (!items || !matchesSubCat) {
      return items;
    }
    return items.filter(item => matchesSubCat(item));
  }
}
